import React, { ReactChild } from 'react'

type Props = {
  children: ReactChild
  showSearch: () => void
  className: string
}

const SearchButton: React.FC<Props> = ({ className, showSearch, children }) => (
  <button
    className={className}
    aria-label="Search"
    data-test-id="centre-search"
    onClick={showSearch}
  >
    {children}
  </button>
)

export default SearchButton
